import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { ROUTE_PATHS } from '../../../routing/routes.pojo';
import { ConsultationFacade } from '../services/consultation/consultation-facade';
import { ConsultationState } from '../services/state/consultation-state';

export const newConsultationGuard: CanActivateFn = async () => {
  const consultationFacade = inject(ConsultationFacade);
  const consultationState = inject(ConsultationState);
  const router = inject(Router);

  await consultationFacade.startConsultation();

  const newConsultationId = consultationState.consultationId();

  return router.createUrlTree([
    '/',
    ROUTE_PATHS.consultation,
    newConsultationId,
  ]);
};
